var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "100%" }, attrs: { id: "app" } },
    [
      _c("meta", {
        attrs: {
          name: "viewport",
          content: "width=device-width, user-scalable=no"
        }
      }),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: {
            name: "vux-pop-" + (_vm.direction === "forward" ? "in" : "out")
          },
          on: {
            "after-enter": function($event) {
              _vm.$vux.bus && _vm.$vux.bus.$emit("vux:after-view-enter")
            }
          }
        },
        [
          _c("router-view", {
            key: _vm.$route.path,
            staticClass: "router-view",
            attrs: { id: "routerView" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 